import { Box, Flex, VStack, HStack } from "@chakra-ui/react";
import { useIdentity } from "context/auth";
import parseHTML from "html-react-parser";
import { SupportTicketComment } from "models/support";
import { FC } from "react";

const CommentDate: FC<{ comment: SupportTicketComment }> = ({ comment }) => {
    const createdAt = new Date(comment.createdAt);
    const createdAtDate = createdAt.toLocaleDateString();
    const createdAtTime = createdAt.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });

    return (
        <HStack
            color="white"
            fontSize="1em"
            fontWeight="semibold"
            spacing={0}
            alignItems="end"
        >
            <Box as="span" opacity={0.95}>
                {createdAtTime}
            </Box>
            <Box as="span" opacity={0.75}>
                , {createdAtDate}
            </Box>
        </HStack>
    );
};

const TicketComment: FC<{ comment: SupportTicketComment; isTop: boolean }> = ({
    comment,
    isTop,
}) => {
    const { zendeskUserId } = useIdentity();
    const { authorName, htmlBody } = comment;

    const isAuthor = zendeskUserId === "" + comment.authorId;

    return (
        <VStack
            px={2}
            pr={6}
            py={2}
            pb={6}
            w="100%"
            align="start"
            spacing={2}
            fontSize="14"
            color="white"
            borderTop="1px solid white"
        >
            <Flex alignItems="center" justifyContent="space-between" w="100%">
                <Box
                    fontWeight="semibold"
                    fontSize="1.2em"
                    lineHeight="1em"
                    pl={2}
                >
                    {authorName}
                    {isAuthor && (
                        <Box
                            fontSize={16}
                            pl=".5em"
                            as="span"
                            fontWeight="normal"
                        >
                            (you)
                        </Box>
                    )}
                </Box>
                <CommentDate comment={comment} />
            </Flex>
            <Box pl={6}>{parseHTML(htmlBody)}</Box>
        </VStack>
    );
};

export default TicketComment;
